import { resolveInvalidatesForLogging, type CreateQueryClientOptions } from '@zg-rentals/react-query5';

import { HpApiWebApiError } from '@zg-rentals/ts-hotpads-api-client';
import { isClientError, isPerimeterXBlockedError } from '@/src/lib/api/client/apiClient';
import { v3ErrorReason } from '@/src/lib/api/client/hotpadsApiV3Client';
import { PRICE_HISTORY_QUERY_DETAILS } from '@/src/lib/utils/priceHistoryIdentity';

function isExpectedMessagesUnauthorized(error: Error, queryMeta?: { context?: Record<string, unknown> }): boolean {
  return (
    error.name === 'DatarouterError' &&
    'responseStatus' in error &&
    error.responseStatus === 401 &&
    queryMeta?.context?.api === 'satellite-api' &&
    (queryMeta.context.details === 'getMessages' || queryMeta.context.details === 'getLatestConversations')
  );
}

// hotpads-api answers restricted listings' price history with a FORBIDDEN envelope; the HDP hides the section.
function isExpectedPriceHistoryForbidden(error: Error, queryMeta?: { context?: Record<string, unknown> }): boolean {
  return (
    queryMeta?.context?.details === PRICE_HISTORY_QUERY_DETAILS && v3ErrorReason(error) === HpApiWebApiError.FORBIDDEN
  );
}

export const queryClientOptions = {
  shouldLogQueryError: (error, _queryKey, queryMeta) =>
    !isPerimeterXBlockedError(error) &&
    !isClientError(error) &&
    !isExpectedMessagesUnauthorized(error, queryMeta) &&
    !isExpectedPriceHistoryForbidden(error, queryMeta),

  // Mutation variables carry credentials (current/new passwords, reset tokens, login) and the
  // default context serializes them to Splunk verbatim. meta.context is the sanctioned
  // observability channel and is hand-authored, so it cannot leak a secret by accident.
  mutationErrorContext: (_error, _variables, mutationMeta) => ({
    invalidates: resolveInvalidatesForLogging(mutationMeta?.invalidates),
    ...mutationMeta?.context,
  }),
} satisfies CreateQueryClientOptions;
